import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import UpdateShareholderDetail from '../../components/admincomponents/UpdateShareholderDetail';

function UpdateProject({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <UpdateShareholderDetail />            
    </>
  );
}

export default UpdateProject;
